import logo from './logo.svg';
import './App.css';
import TokenInfo from './components/TokenInfo';
import Navbar from './components/Navbar';
import Footer from './components/Footer';


function App() {
  return (
    <>
   
<Navbar />


    <TokenInfo />
    <Footer />
    </>
  );
}

export default App;
